import v3ApiClient from "./client";

const OPERATION_PREFIX = "/v3/operation";

function unwrapOperationPayload(response) {
    return response?.data?.data ?? response?.data ?? response;
}

export const operationApi = {
    listLegs: async ({ aircraft, date_from, date_to, sort_by, sort_order } = {}) => {
        const response = await v3ApiClient.get(`${OPERATION_PREFIX}/legs`, {
            params: {
                aircraft,
                date_from,
                date_to,
                ...(sort_by ? { sort_by, sort_order: sort_order || "asc" } : {}),
            },
        });
        return unwrapOperationPayload(response);
    },
    listItemsForLeg: async ({ legId } = {}) => {
        const response = await v3ApiClient.get(`${OPERATION_PREFIX}/legs/${legId}/items`);
        return unwrapOperationPayload(response);
    },
    getItem: async ({ itemId } = {}) => {
        const response = await v3ApiClient.get(`${OPERATION_PREFIX}/items/${itemId}`);
        return unwrapOperationPayload(response);
    },
    updateItem: async ({ itemId, fieldKey, value, fields, expectedLockVersion } = {}) => {
        const updateFields = fields || { [fieldKey]: value };
        const response = await v3ApiClient.patch(`${OPERATION_PREFIX}/items/${itemId}`, {
            fields: updateFields,
            expected_lock_version: expectedLockVersion,
        });
        return unwrapOperationPayload(response);
    },
    batchUpdateItems: async ({ operations } = {}) => {
        const response = await v3ApiClient.post(`${OPERATION_PREFIX}/items/batch`, { operations });
        return unwrapOperationPayload(response);
    },
    createItem: async ({ legId, category, status = "", remarks = null, attributes = {}, orderId = null } = {}) => {
        const response = await v3ApiClient.post(`${OPERATION_PREFIX}/items`, {
            leg_id: legId,
            category,
            status,
            remarks,
            attributes,
            order_id: orderId,
        });
        return unwrapOperationPayload(response);
    },
    deleteItem: async ({ itemId } = {}) => {
        const response = await v3ApiClient.delete(`${OPERATION_PREFIX}/items/${itemId}`);
        return unwrapOperationPayload(response);
    },
};

export default operationApi;
